// Copyright © 2021 Move Closer
export var ImageSelectionOptions;
(function (ImageSelectionOptions) {
    ImageSelectionOptions["Default"] = "default";
    ImageSelectionOptions["Smart"] = "smart";
})(ImageSelectionOptions || (ImageSelectionOptions = {}));
export var FileDataActions;
(function (FileDataActions) {
    FileDataActions["None"] = "none";
    FileDataActions["Preview"] = "preview";
    FileDataActions["Link"] = "link";
})(FileDataActions || (FileDataActions = {}));
